import { useCallback, useRef, useState } from 'react';
import { SizeObjType } from '@interfaces/models/mySizes';

export interface SizesStepValueData {
  id: string;
  label: string;
  sizes: SizeObjType[];
}

export type SizesStepValueCollection = Record<string, SizesStepValueData>;

// Custom hook for managing sizes step values state
export const useSizesStepValues = () => {
  const [stepValue, setStepValue] = useState<SizesStepValueCollection>({});
  const stepValueRef = useRef<SizesStepValueCollection>({});

  const updateStepValue = useCallback((newValue: SizesStepValueCollection) => {
    setStepValue(newValue);
    stepValueRef.current = newValue;
  }, []);

  const resetStepValues = useCallback(() => {
    setStepValue({});
    stepValueRef.current = {};
  }, []);

  return { stepValue, stepValueRef, updateStepValue, resetStepValues };
};
